export enum ERole {
    CLIENTE = 'Cliente',
    ADMINISTRADOR = 'Administrador',
    USUARIO = 'Usuario',
    ESTUDIANTE = 'Estudiante'
}